export enum TabsIndicatorCssVars {
  /**
   * Indicates the distance on the left side from the parent's container if the tab is active.
   * @type {number}
   */
  activeTabLeft = '--active-tab-left',
  /**
   * Indicates the distance on the right side from the parent's container if the tab is active.
   * @type {number}
   */
  activeTabRight = '--active-tab-right',
  /**
   * Indicates the distance on the top side from the parent's container if the tab is active.
   * @type {number}
   */
  activeTabTop = '--active-tab-top',
  /**
   * Indicates the distance on the bottom side from the parent's container if the tab is active.
   * @type {number}
   */
  activeTabBottom = '--active-tab-bottom',
  /**
   * Indicates the width of the tab if it is active.
   * @type {number}
   */
  activeTabWidth = '--active-tab-width',
  /**
   * Indicates the height of the tab if it is active.
   * @type {number}
   */
  activeTabHeight = '--active-tab-height',
}
